import { Column, Row } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { ExpiresOn } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { ExpirationOptionSelect } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/ExpirationOptionSelect';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { DeactivationDateInputWrapper } from './DeactivationDateInputWrapper';

export function DeactivationFields(): JSX.Element {
  const {
    isEditing,
    formValues: { expiresOn },
    mealCredit,
  } = useMealCreditFormData();
  return (
    <Row gutter={12}>
      <Column phone={3} gutter={12}>
        <ExpirationOptionSelect
          disabled={
            isEditing &&
            mealCredit.expiration &&
            expiresOn === ExpiresOn.ON_THIS_DAY
          }
          id="expiresOn"
          name="expiresOn"
        />
      </Column>
      <Column desktop={2} phone={3} gutter={12}>
        <DeactivationDateInputWrapper />
      </Column>
    </Row>
  );
}
